export default function() {
    const ascending = this.orderBy.ascending ? 1 : 0;
    const orderBy = this.orderBy.column ? this.orderBy.column : null;
    const typeDate = localStorage.getItem('timezones');
    const timezoneDevice = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const queries = Object.assign(
        {},
        { query: this.query },
        this.customQueries,
        { orderBy },
        { ascending },
        { typeDate },
        { timezoneDevice },
    );
    // const queryString = Object.entries(queries).map(([key, val]) => `${key}=${val}`).join('&');

    return $.param(queries);
}



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/methods/get-query-parameters.js